import { Modal } from '@odin-labs/components';
import React from 'react';

export type DiscardDraftModalProps = {
  isOpen: boolean;
  discarding: boolean;
  onCancel: () => void;
  onDiscard: () => void;
};

export function DiscardDraftModal({
  isOpen,
  discarding,
  onCancel,
  onDiscard,
}: DiscardDraftModalProps): React.ReactElement {
  return (
    <Modal
      open={isOpen}
      setOpen={(open) => !open && onCancel()}
      title="Discard draft"
      text="Discard all unpublished changes? Reader placements return to the published layout."
      size="sm"
      actionText="Discard draft"
      actionButtonTheme="danger"
      actionButtonWithSpinner={discarding}
      onAction={onDiscard}
      cancelText="Keep draft"
      onCancel={onCancel}
    />
  );
}
